import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Roles } from '@utils/roles';
import { isNil } from 'lodash';
import * as moment from 'moment';
import { filter, map, Observable, Subject, takeUntil, tap } from 'rxjs';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { NotificationsService } from '@geekbears/ngx-gb-ui-kit';

import {
  getAllUsersFailureAction,
  getAllUsersSuccessAction,
  UsersActions,
  allUsersLoadingSelector,
  usersCountSuccessSelector,
} from '@modules/company-manager/users/application';
import { Company } from '@modules/super-admin/company/domain';
import { AppUser } from '@modules/company-manager/users/domain';

@Component({
  selector: 'company-manager-home',
  templateUrl: './company-manager.container.html',
  styleUrls: ['./company-manager.container.scss'],
})
export class CompanyManagerContainer implements OnInit {
  /**
   * @destroy$ is used to unsubscribe from all subscriptions
   */
  destroy$: Subject<void> = new Subject();
  detailsSelected: string = '';
  currentPage: number = 1;
  itemsPerPages: number = 6;

  usersComplete!: any[];
  users!: any[];
  usersLoading$: Observable<boolean | undefined>;
  lastUpdated!: any;

  usersFlag$!: Observable<any>;
  currentCompany!: Company;
  usersCount$: Observable<any>;

  constructor(
    private store$: Store,
    private actions$: Actions,
    private notificationsService: NotificationsService,
    private router: Router
  ) {
    this.usersLoading$ = this.store$.select(allUsersLoadingSelector);
    this.usersCount$ = this.store$.select(usersCountSuccessSelector);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCompanyId() {
    let currentUser = JSON.parse(localStorage.getItem('s_user') || '{}');
    if (currentUser) {
      this.getAllUsers(currentUser._companyId);
      this.getUsersCount(currentUser._companyId);
    }
  }

  ngAfterViewInit(): void {
    this.getCompanyId();
  }
  getAllUsers(companyId: string) {
    this.store$.dispatch(
      UsersActions.getAllUsers({
        companyId: companyId,
      })
    );
  }

  ngOnInit(): void {
    this.onFailureActions();
    this.usersFlag$ = this.actions$.pipe(
      ofType(getAllUsersSuccessAction),
      filter((action) => {
        return !isNil(action.users);
      }),
      map((action: any) => {
        if (action) {
          this.users = action.users.data;
          this.usersComplete = action.users.data;
          return action.users.data;
        }
      }),
      tap((users: any[]) => {
        if (users.length > 0) {
          this.lastUpdated = moment(users[users.length - 1].createdAt).format(
            'MM/DD/YYYY'
          );

          this.currentCompany = this.users[0].company.companyName;
        }
      })
    );
  }

  userType(roles: string[]) {
    if (roles.find((role) => role == Roles.companyAdministrator)) {
      return 'Company Administrator';
    }
    if (roles.find((role) => role == 'approver')) {
      return 'Approver';
    }
    if (roles.find((role) => role == 'requester')) {
      return 'Requester';
    }
    return '';
  }

  pageChanged(event: any) {
    this.currentPage = event;
  }

  filterChange(event: any) {
    this.users = this.usersComplete.filter((client) =>
      JSON.stringify(client)
        .toLocaleLowerCase()
        .includes(event.toLocaleLowerCase())
    );
  }

  getUsersCount(companyId: string) {
    this.store$.dispatch(
      UsersActions.getUsersCount({
        companyId: companyId,
      })
    );
  }
  onFailureActions() {
    this.actions$
      .pipe(
        ofType(getAllUsersFailureAction),
        map((action: any) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          if (errorMessage) {
            this.notificationsService.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  userDetails(user: AppUser) {
    this.router.navigateByUrl(`dashboard/users/user-details/${user.id}`);
  }
}
